var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" Form 35A Details ")]),_c('v-card-text',[_c('p',[_vm._v("The id passed in was "+_vm._s(_vm.itemId))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }